const isHideFieldReport = (listHideFieldReport: EHideFieldReport[], field: EHideFieldReport) => {
  return listHideFieldReport.includes(field);
};

enum EHideFieldReport {
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  COMMISSION = 'COMMISSION',
  PERCENT_COMMISSION = 'PERCENT_COMMISSION',
  TIP = 'TIP',
  SUPPLY_FEE = 'SUPPLY_FEE',
  TOTAL = 'TOTAL',
  TOTAL_SALE = 'TOTAL_SALE',
  DISCOUNT = 'DISCOUNT',
  TIP_COLLECTED = 'TIP_COLLECTED',
  TIP_FEE = 'TIP_FEE',
  TOTAL_TIP = 'TOTAL_TIP',
  CLEANING_FEE = 'CLEANING_FEE',
  PAYROLL = 'PAYROLL',
  BONUS = 'BONUS',
  CHECK = 'CHECK',
  TIP_TO_BONUS = 'TIP_TO_BONUS',
  TIP_TO_CHECK = 'TIP_TO_CHECK',
  FEDERAL_TAX_WITHHELD = 'FEDERAL_TAX_WITHHELD',
  SOCIAL_SECURITY_TAX_WITHHELD = 'SOCIAL_SECURITY_TAX_WITHHELD',
  MEDICARE_TAX_WITHHELD = 'MEDICARE_TAX_WITHHELD',
  TOTAL_BONUS = 'TOTAL_BONUS',
  TOTAL_CHECK = 'TOTAL_CHECK',
  SHOW_PERCENTAGE = 'SHOW_PERCENTAGE',
}

export { isHideFieldReport, EHideFieldReport };
